<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>내 비방사전 관리</h2>
      </div>

      <article class="view cmnity">
        <div class="search_box" style="flex-wrap: wrap">
          <p class="w100 mb20">
            총
            <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
          </p>
          <div class="flex items-center justify-between w100">
            <div class="form_inline">
              <div class="form_select">
                <span class="fwb mr10">카테고리</span>
                <b-form-select v-model="searchInfo.prescribe_category" @change="fn_change_prescript_catarory">
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                </b-form-select>
                <b-form-select v-model="searchInfo.prescribe_sub_category" class="ml10">
                  <b-form-select-option value="">선택</b-form-select-option>
                  <b-form-select-option v-for="(item, index) in prescrbeSubCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                </b-form-select>
              </div>
              <span class="fwb ml10 mr10">비방명</span>
              <input
                type="text"
                class="form_control"
                placeholder="비방명을 입력하세요."
              />
            </div>
            <div class="form_inline">
              <button class="btn btn_md btn_darkbrown" @click="fn_search">검색</button>
              <button
                class="btn btn_md btn_brown"
                @click="fn_move_regPage"
              >
                비방 신규 등록
              </button>
            </div>
          </div>
        </div>
        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <colgroup>
                  <col width="150" />
                  <col width="*" />
                  <col width="200" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>비방처방명</th>
                    <th>카테고리</th>
                    <th>적응중</th>
                    <th>출처</th>
                    <th>진행상황</th>
                    <th>작업</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="formulaLibraryList.length == 0">
                    <td colspan="7"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in formulaLibraryList"
                    :key="index"
                  >
                    <td @click="fn_move_dtl_page(item.secret_prescription_seq)"><span>{{ searchInfo.pageInfo.totPage - ( (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize) - index}}</span></td>
                    <td class="ac" @click="fn_move_dtl_page(item.secret_prescription_seq)">
                      <span>{{ item.prescribe_nm }}</span>
                    </td>
                    <td @click="fn_move_dtl_page(item.secret_prescription_seq)">
                      <span>{{ item.prescribe_category_nm }}</span>
                    </td>
                    <td @click="fn_move_dtl_page(item.secret_prescription_seq)">
                      <span>{{ item.indications }}</span>
                    </td>
                    <td @click="fn_move_dtl_page(item.secret_prescription_seq)">
                      <span>{{ item.prescribe_source }}</span>
                    </td>
                    <td @click="fn_move_dtl_page(item.secret_prescription_seq)">
                      <span>{{ item.progress_status_nm }}</span>
                    </td>
                    <td>
                      <div class="flex justify-center">
                        <button v-if="item.progress_status == 'RJ'" class="bdge" @click="fn_move_reReg_page(item.secret_prescription_seq)" >재등록</button>
                        <button v-else class="bdge" @click="fn_move_dtl_page(item.secret_prescription_seq)">내용확인</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"

export default {
  components: {
    Pagination,
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo : {
          prescribe_nm : '',
          clinic_doctor_id : '',
          prescribe_category : '',
          prescribe_sub_category : '',
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }                
      },
      pagingShow : false,
      formulaLibraryList: [],
      prescrbeCategoryList : [],
      prescrbeSubCategoryList : [],
      selected: null,
    };
  },
  async created(){

      //검색정보 처리
      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];  
      
      console.log("@@@@@ searchInfoStore : %o ",searchInfoStore);
      
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore
      }

      this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

      this.prescrbeCategoryList = await this.getCode('GC00000015'); 
  },
  mounted(){
    this.fn_search();
  },
  methods : {
    fn_search(){

      axios
          .post("/api/user/hanidata/getMyFormulaLibraryList", this.searchInfo)
          .then((res) => {
              console.log("@@@@ res : %o",res);
              this.formulaLibraryList = res.data.myFormulaLibraryList;

              console.log("@@@@ formulaLibraryList : %o",this.formulaLibraryList);

              this.searchInfo.pageInfo.totPage = res.data.totCnt;
              
              if(this.searchInfo.pageInfo.totPage> 0){
                  this.pagingShow = true;                          
              }                        

          })
          .catch((err) => console.log(err));
      },
    movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
    },
    fn_move_regPage(){
        this.$router.push("/hanidata/MyFormulaLibraryWrite");
    },
    fn_move_dtl_page(seq){
        this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
        this.$router.push("/hanidata/myFormulaLibraryDetail");

    },
    fn_move_reReg_page(seq){
      this.$store.dispatch('detailSearchInfo/setSearchId', seq);
      this.$store.dispatch('detailSearchInfo/setStatus', 'M');
      this.$router.push("/hanidata/MyFormulaLibraryWrite");
    },
    async fn_change_prescript_catarory(){
      // 선택된 카테고리에 따른 상세 변경 처리
      if(this.searchInfo.prescribe_category !== ''){
        //카테고리값을 선택한 경우
        const list = await this.getDtlCode('GC00000015',this.searchInfo.prescribe_category);
        this.prescrbeSubCategoryList = list || [];
      }else{
        //카테고리값을 선택으로 초기화 한 경우
        this.prescrbeSubCategoryList = [];
      }

      // 기선택 정보 초기화
      this.searchInfo.prescribe_sub_category = '';
    }
  }
  
};
</script>
